import { ComponentProps } from 'preact';
import { Icon } from './Icon';
import { useTheme } from '../hooks/UNSAFE_useTheme';

type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;

type ThemeType = ReturnType<typeof useTheme>;

type ThemeIcons = Record<ThemeType['name'], typeof Icon>;

// Returns a component that renders one of the given icon components based on theme
export const withThemeIcon = (themeIcons: ThemeIcons) => {
  return (props: Props) => {
    const { name } = useTheme();
    const Component = themeIcons[name];
    return <Component {...props} />;
  };
};
